import Handlebars from 'handlebars';
import arrayHelpers from './handlebars-helpers/array.js';
import dateHelpers from './handlebars-helpers/date.js';
import stringHelpers from './handlebars-helpers/string.js';

export default class HandlebarsExtended {
	constructor(prompt) {
		this.compiler = Handlebars.create();
		this.prompt = prompt;
		this.registerHelpers();
	}

	registerHelpers() {
		// Register helper library
		this.compiler.registerHelper(arrayHelpers);
		this.compiler.registerHelper(dateHelpers);
		this.compiler.registerHelper(stringHelpers);
	}

	throwOnMissingKeywords() {
		// Check if a keyword is in the text, but not saved as a keyword
		this.compiler.registerHelper('helperMissing', (token) => {
			throw new Error(`Keyword in text but not saved as keyword: {{${token.name}}}`);
		});

		return this;
	}

	renderTemplate(data = {}) {
		const prompt = this.prompt;
		if (!prompt) {
			throw new Error('Missing Prompt for Rendering');
		}

		// capture the field that throws an error to display on the correct text field
		let fieldThatThrew = null;
		try {

			// 1. Compile main template text
			fieldThatThrew = 'text';
			const compiledText = this.compiler.compile(prompt.text)(data);

			// 2. Compile Rules
			const rules = prompt.prompt_rules;
			const compiledRules = [];
			if (Array.isArray(rules) && rules.length > 0) {
				for (let i = 0; i < rules.length; i++) {
					let rule = { ...rules[i] };
					if (rule.rule_text?.includes('{{')) {
						fieldThatThrew = `prompt_rules[${rule.order}]`; // prompt_rules[0] ex. can be checked
						const compiledRuleText = this.compiler.compile(rule.rule_text)(data);
						rule.rule_text = compiledRuleText;
					}

					compiledRules.push(rule);
				}
			}

			// 3. Compile Subject Line
			let compiledSubjectLine;
			if (prompt.subject_line_template) {
				fieldThatThrew = 'subject_line_template';
				compiledSubjectLine = this.compiler
					.compile(prompt.subject_line_template)
					({ main_body: '{{main_body}}', ...data })
			}

			// 3. Compile Preview Text
			let compiledPreviewText;
			if (prompt.preview_text_template) {
				fieldThatThrew = 'preview_text_template';
				compiledPreviewText = this.compiler
					.compile(prompt.preview_text_template)
					({ main_body: '{{main_body}}', ...data });
			}

			return {
				text: compiledText,
				prompt_rules: compiledRules,
				subject_line_template: compiledSubjectLine,
				preview_text_template: compiledPreviewText
			}
		} catch (error) {
			const validationErr = new Error(error);
			validationErr.field = fieldThatThrew;
			throw validationErr;
		}
	}
}

class ValidationError extends Error {
	constructor(message) {
		super(message);
		this.field; // The field that threw the error
	}
}